// BookingApprove.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import CustomTable from "../../components/custom_table/CustomTable.jsx";
// import { Icon } from "lucide-react";
import { Box } from "@mui/material";
import { baseUrl } from "../../helper/urls.js";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
const BookingApprove = ({ status }) => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  // const counselor = location.state;

  const [counselors, setCounselors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCounselors = async () => {
    try {
      // console.log("akkkkkkkkkkkkkkkkkkk", counselor);
      const response = await axios.get(
        `${baseUrl}/bookings/counselor/counselorId/status/${status}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("akkkkkkkkkkkkkkkkkkk11111");
      console.log("response:::::::::::::::::::::::::::::::", response.data);
      setCounselors(response.data);
      setLoading(false);
    } catch (error) {
      setError("error bookingwihtaaaaaaaaaaaa", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounselors();
  }, []);

  const toggleApproval = async (id, currentStatus) => {
    const newStatus = currentStatus;
    const action = newStatus === 1 ? "Accept" : "Reject";

    const result = await Swal.fire({
      title: `Are you sure ?`,
      text: `You want to ${action.toLowerCase()} this booking.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${action}`,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      await axios.patch(
        `${baseUrl}/bookings/status/${id}`,
        { status: newStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire(
        "Success",
        `Booking ${action.toLowerCase()}ed successfully!`,
        "success"
      );

      if (newStatus === 1) {
        navigate("/approved-bookings");
      } else {
        navigate("/unapproved-bookings");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    }
  };
  const statusMap = {
    0: "Pending",
    1: "Accepted",
    2: "Paid",
    3: "Rejected",
    4: "Upcoming",
    5: "Completed",
  };
  const statusMapType = {
    0: "default",
    1: "success",
    2: "secondary",
    3: "error",
    4: "warning",
    5: "info",
  };
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("id", { header: "ID" }),
    columnHelper.accessor("student_id", {
      header: "Student Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.firstName + " " + cell.row.original?.lastName,
    }),
    columnHelper.accessor("booking_date", {
      header: "Booking Date",
      size: 30,
      Cell: (cell) => cell.row.original?.booking_date?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("booking_duration", {
      header: "Duration(mins)",
      size: 30,
      Cell: (cell) => cell.row.original?.booking_duration,
    }),
    columnHelper.accessor("slot_id", {
      header: "Slot Details",
      size: 40,
      Cell: (cell) =>
        cell.row.original?.booking_time + " to " + cell.row.original?.end_time,
    }),
    columnHelper.accessor("status", {
      header: "Status",

      Cell: (cell) => {
        const status = cell.row.original.status;
        return (
          (
            <Chip
              label={statusMap[status]}
              color={statusMapType[status]}
              variant="outlined"
            />
          ) || <Chip label="Pending" color="default" variant="outlined" />
        );
      },
    }),

    // columnHelper.accessor("Actions", {
    //   header: "Actions",
    //   Cell: ({ cell }) => {
    //     const rowId = cell.row.original.id;
    //     const rowData = cell.row.original;

    //     return (
    //       <Box>
    //         <button
    //           onClick={() => toggleApproval(rowId, 1)}
    //           className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
    //           style={{ cursor: "pointer" }}
    //         >
    //           <Icon icon="material-symbols:check" />
    //         </button>

    //                                      <button
    //                                          onClick={() => toggleApproval(rowId, 3)}
    //                                          className="w-32-px h-32-px bg-warning-focus text-warning-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
    //                                          style={{ cursor: 'pointer' }}
    //                                      >
    //                                          <Icon icon="ic:round-close" />
    //                                      </button>

    //       </Box>
    //     );
    //   },
    // }),
  ];

  return <CustomTable columns={columns} data={counselors} loading={loading} />;
};

export default BookingApprove;
